module.exports = __webpack_public_path__ + "static/media/margueritte.480972dd.png";